module.exports = __webpack_public_path__ + "static/media/saudi.05a35020.png";